import { auth } from "auth"

export const getUserId = async () => {
  return (await auth.getActiveSession()).userId
}

export const getCompanyNameKey = async () => {
  return (await auth.getActiveSession()).companyNameKey
}
